import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

/**
 * Entity Top Sells Action Types
 */
export const GET_ENTITY_TOP_SELLS_REQUEST = 'GET_ENTITY_TOP_SELLS_REQUEST'
export const GET_ENTITY_TOP_SELLS_SUCCESS = 'GET_ENTITY_TOP_SELLS_SUCCESS'
export const GET_ENTITY_TOP_SELLS_FAILURE = 'GET_ENTITY_TOP_SELLS_FAILURE'

export const RESET_ENTITY_TOP_SELLS = 'RESET_ENTITY_TOP_SELLS'

/**
 * Get Entity Top Sells
 * @param params
 * @param options.types - action types
 * @private
 */
const _getTopSells = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_ENTITY_TOP_SELLS_REQUEST,
      GET_ENTITY_TOP_SELLS_SUCCESS,
      GET_ENTITY_TOP_SELLS_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: `/ownership/v2/${params.entityType}/${params.entityId}/sells`
  }
})

/**
 * Dispatch GET_ENTITY_TOP_SELLS_REQUEST
 */
export const getTopSells = (params, options) => (dispatch) => {
  return dispatch(_getTopSells(params, options))
}

/**
 * Dispatch RESET_ENTITY_TOP_SELLS
 */
export const resetTopSells = () => (dispatch) => {
  return dispatch({ type: RESET_ENTITY_TOP_SELLS })
}
